// Live (OTA) updates of the bundled web screens, self-hosted on dubuck.com (no Capgo cloud).
// The deploy workflow publishes /ota/latest.json + /ota/<version>.zip; the app downloads a newer bundle in the
// background and switches to it on the next launch/background. If a bundle fails to start (notifyAppReady not
// reached within appReadyTimeout), the plugin rolls back to the previous one by itself.
// Native changes (plugins, icons, permissions) still need a store release: a bundle only installs on the
// native version it was built for (package.json "nativeVersion" must match the store app's version name).
import axios from 'axios';
import { App } from '@capacitor/app';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { isNative, API_ORIGIN } from './native';

// Set by the deploy workflow; empty in local/store builds, which then just take the latest bundle once
const BUILD = process.env.REACT_APP_BUILD || '';

export default async function setupOta() {
  if (!isNative) return;
  // Tell the plugin this bundle started fine, so it won't roll back
  CapacitorUpdater.notifyAppReady().catch(() => { });
  try {
    const { data: latest } = await axios.get(`${API_ORIGIN}/ota/latest.json`, { params: { t: Date.now() } });
    const { version: native } = await App.getInfo();
    if (!latest.version || latest.version === BUILD || latest.native !== native) return;
    const { bundle } = await CapacitorUpdater.current();
    if (bundle.version === latest.version) return;
    const next = await CapacitorUpdater.download({ url: latest.url, version: latest.version, checksum: latest.checksum });
    await CapacitorUpdater.next({ id: next.id });
  } catch (e) {
    // Offline or a bad download: keep the current bundle and try again next launch
  }
}
